import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26f6c3f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "map-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend" }, null, -1))

import AirStatusMap from '@/pages/main/pages/airStatus/componets/airStatusMap/index.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AirStatusMap),
    _createElementVNode("div", {
      class: "aqi-map",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/mapNotLogin/threeDimensional')))
    }),
    _hoisted_2
  ]))
}
}

})